if (!customElements.get('product-matches')) {
  class ProductMatches extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 600px 0px'}).observe(this);
    }

    handleIntersection(entries, observer) {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');

          if (html === null) return;

          const matches = html.querySelector('product-matches');
          if (matches && matches.innerHTML.trim().length) {
            this.innerHTML = matches.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('product-matches', ProductMatches);
}
